import React, { Component, Fragment } from 'react';
import { CardLayout, TableLayout } from '../containers/Layout';
import { TableRow, TableCell, Button, Grid, TableHead, TableFooter, Box, TableBody, Typography } from '@material-ui/core';
import SingleTemplate from '../containers/SingleTemplate';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class SingleBL extends Component {
    state = { }

    componentDidMount = () => {
        console.log("[INFO] MOUNTING SALE SINGLE ");
    }
    createProductList = () => {
        const { PRODUCTS, transfer } = this.props

        return transfer.products.map( transferItem => {
            let prod = PRODUCTS[transferItem.product_id]
            // const ssTt = parseFloat(transferItem.price) // prix vendu
            // let PU = transferItem.price / transferItem.quantity

            return (
                <TableRow>
                        <TableCell className="lightbox-item p-item">
                        {prod.photos &&
                            <img 
                                id={prod.photos[0].filename} 
                                src={`/stocks/photos/${prod.photos[0].filename}`} 
                                style={{width:"100px", height:"auto"}}
                            />
                        }
                    </TableCell>
                    <TableCell className="text-left" >
                        <b>{prod.name}</b> <br />
                        - <i> {prod.ref}</i>
                    </TableCell>
                    <TableCell>{transferItem.quantity}</TableCell>
                    <TableCell>{prod.poids}</TableCell>
                    <TableCell>{prod.poids * transferItem.quantity}</TableCell>
                    
                    {/* <TableCell>{formatNumbers.format(PU)}</TableCell>
                    <TableCell>{formatNumbers.format(ssTt)}</TableCell>
                    <TableCell>{shop.TVA || 0} %</TableCell>
                    <TableCell>{formatNumbers.format(ssTt)}</TableCell> */}
                </TableRow>
            )
        })
    }

    getTotal = () => {
        const { PRODUCTS, transfer } = this.props
        let total = 0
        let qty = 0
        transfer.products.map( transferItem => {
            let prod = PRODUCTS[transferItem.product_id]
            const poids = parseFloat(prod.poids * transferItem.quantity)
            total += poids  
            qty += transferItem.quantity
        })
        
        return {total, qty}
    }
    
    render(){
        console.log("[STATE] PRODUCT",this.props);
        let total = this.getTotal()
        return(
            // <SingleTemplate
            //     shop={shop}    
            //     shopDest={shopDest}    
            //     transfer={transfer}   
            //     notif={this.props.notif} 
            //     BL
            // >
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell >Photo</TableCell>
                            <TableCell className="text-left">Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>Poid Unitaire (kg)</TableCell>
                            <TableCell>Poid Total (kg)</TableCell>
                            {/* <TableCell>Total HT</TableCell>
                            <TableCell>TVA</TableCell>
                            <TableCell>Total TTC</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.createProductList()}
                        <TableRow>
                            <TableCell colSpan={5}></TableCell>
                        </TableRow>
                        {/* <TableRow>
                            <TableCell colSpan={2}></TableCell>
                            <TableCell>Sous Total</TableCell>
                            <TableCell>
                                {formatNumbers.format(total)}
                            </TableCell>
                            
                            <TableCell></TableCell>
                            <TableCell className="f-700">
                                {formatNumbers.format(total)}
                            </TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell colSpan={5} style={{textAlign: "right"}} >Transport</TableCell>
                            <TableCell>
                                {formatNumbers.format(transfer.transport || 0)}
                            </TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell colSpan={5} style={{textAlign: "right"}} >Autres Taxes</TableCell>
                            <TableCell>
                                {formatNumbers.format(transfer.taxes || 0)}
                            </TableCell>
                        </TableRow> */}
                    </TableBody>   
                    <TableFooter> 
                        <TableRow>
                            <TableCell style={{textAlign: "right", fontSize:"18px"}}>Totaux</TableCell>
                            <TableCell ></TableCell>
                            <TableCell  style={{fontSize:"18px"}}>
                                <b>{formatNumbers.format(total.qty)}</b>
                            </TableCell>
                            <TableCell ></TableCell>
                            <TableCell  style={{fontSize:"18px"}}>
                                <b>{formatNumbers.format(total.total)}</b>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </TableLayout>     
            // </SingleTemplate>
        )
    }
}

export default SingleBL;